(function () {
    const CLASS_NAME = 'header-search';

    const componentHeaderSearch = {
        $body: null,
        $form: null,
        $input: null,
        $modal: null,
        $notFound: null,
        $content: null,
        $header: null,
        $buttonSearch: null,
        $recommended: null,
        $suggestionsContainer: null,
        $suggestion: null,
        $title: null,
        $close: null,
        $collections: null,
        $collectionsResults: null,
        $productsContainer: null,
        isPredictiveSearch: true,

        init() {
            this.initElements();

            this.addInputClickEventListener();
            this.addInputEventListener();
            this.addSuggestionClickEventListener();
            this.addCloseClickEventListener();
            this.addScrollListener()
            this.addBodyClickEventListener();
            this.addSubmitFormListener();
        },

        initElements: function () {
            this.$body = document.querySelector(`body`);
            this.$header = document.querySelector(`.header`);
            this.$siteAlert = document.querySelector(`.js-siteAlert`)
            this.$form = document.querySelector(`.${CLASS_NAME}__form`);
            this.$input = document.querySelector(`.${CLASS_NAME}__input`);
            this.$modal = document.querySelector(`.${CLASS_NAME}__modal`);
            this.$notFound = document.querySelector(`.${CLASS_NAME}__not-found`);
            this.$suggestionsContainer = document.querySelector(`.${CLASS_NAME}__suggestions`);
            this.$recommended = document.querySelector(`.${CLASS_NAME}__recommended`);
            this.$content = document.querySelector(`.${CLASS_NAME}__content`);
            this.$buttonSearch = document.querySelector(`.${CLASS_NAME}__button-search`);
            this.$productsContainer = document.querySelector(`.${CLASS_NAME}__products`);
            this.$suggestionsContainer = document.querySelector(`.${CLASS_NAME}__suggestions`)
            this.$title = document.querySelector(`.${CLASS_NAME}__title`)
            this.$close = document.querySelector(`.${CLASS_NAME}__close`)
            this.$collectionsResults = document.querySelector(`.${CLASS_NAME}__collections-results`)
            this.$collections = document.querySelector(`.${CLASS_NAME}__collections`)
        },

        addInputClickEventListener: function() {
            this.$input.addEventListener('click', () => {
                this.showModal()
            });
        },

        addBodyClickEventListener: function () {
            this.$body.addEventListener('click',  (event) => {
                if (this.$body.classList.contains('body-overlay') && !event.target.closest('.header')) {
                    this.hideModal()
                }
            });
        },

        addCloseClickEventListener: function() {
            this.$close.addEventListener('click', () => {
                this.hideModal()
            });
        },

        addSuggestionClickEventListener: function() {
            this.$suggestionsContainer.addEventListener('click', (event) => {
                if (event.target.classList.contains(`${CLASS_NAME}__suggestion`)) {
                    this.pasteSuggestion(event.target.getAttribute('data-query'))
                }
            });
        },

        addInputEventListener: function() {
            this.$input.addEventListener('input', debounce(async () => {
                const query = this.$input.value;
                if (query.length) {
                    await this.querySearch(query)
                } else {
                    this.showRecommended();
                    this.hideNotFound()
                    this.hideProducts();
                    this.hideButtonSearch()
                    this.showContent();
                    this.hideSuggestions();
                }
            }, 500));
        },

        addScrollListener: function () {
            window.addEventListener('scroll', () => {
                const scrollTop = document.documentElement.scrollTop;

                if (
                  this.$siteAlert
                  && scrollTop <= this.$siteAlert.offsetHeight
                ) {
                    const newTop = 64 + this.$siteAlert.offsetHeight - scrollTop;
                    this.$modal.style.top = `${newTop}px`;
                } else {
                    this.$modal.style.top = `64px`;
                }
            });
        },

        addSubmitFormListener: function () {
            this.$form.addEventListener('submit', (event) => {
                event.preventDefault();
                const searchQuery = this.$input.value;
                if (searchQuery.trim() !== '') {
                    window.location.href = `/search?q=${encodeURIComponent(searchQuery)}`;
                }
            });
        },


        showModal: function () {
            this.$modal.classList.add(`${CLASS_NAME}__modal_visible`);
            this.$body.classList.add(`body-overlay`);
            this.$header.classList.add('has-search');
        },

        hideModal: function () {
            this.$modal.classList.remove(`${CLASS_NAME}__modal_visible`);
            this.$body.classList.remove(`body-overlay`);
            this.$header.classList.remove('has-search');
        },


        querySearch: async function (query) {
            const results = await this.queryPredictiveSearch(query) || await this.queryGeneralSearch(query)
            const {products, suggestions, collections} = results;

            this.displayProducts(products)
            this.setButtonSearchLink(query)
            this.displaySuggestions(suggestions, query)
            this.displayCollections(collections)
        },

        queryPredictiveSearch: async function (query) {
            const URL = `/search/suggest.json?q=${query}`;
            try {
                const response = await fetch(URL);
                const data = await response.json();
                const results = data.resources.results
                const collections = results.collections;
                const products = results.products
                const suggestions = results.queries


                if (!collections.length && !products.length && !suggestions.length) {
                    return null
                }

                const resizeImageUrl = (url, size) => {
                    const parts = url.split('.');
                    if (parts.length > 1) {
                        parts[parts.length - 2] += `_${size}`;
                        return parts.join('.');
                    }
                    return url;
                };

                const resizedProducts = products.map(product => {
                    if (product.image) {
                        const resizedImageUrl = resizeImageUrl(product.image, '300x');
                        return {...product, featured_image: {url: resizedImageUrl}, tags: window.getTags(product.tags)};
                    }
                    return product;
                });


                this.isPredictiveSearch = true;

                return {
                    collections,
                    products: resizedProducts,
                    suggestions
                }
            } catch (error) {
                console.error('Error', error);
            }
        },

        queryGeneralSearch: async function (query) {
            const SHOP_URL = 'https://12-storeez-uz.myshopify.com'
            const ACCESS_TOKEN = '112b7330c5d8676b9125c6053656b3b7'
            const isBarcode = /^\d{6}$/.test(query);
            const searchQuery = isBarcode ? `"*${query}*"` : `"title:*${query}*"`;


            const headers = {
                'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
                'Content-Type': 'application/json'
            };

            const graphqlQuery = `
                query searchProducts {
                    products(first: 10, query: ${searchQuery}) {
                        edges {
                          cursor
                          node {
                            ... on Product {
                                handle
                                title
                                id
                                onlineStoreUrl
                                availableForSale
                                featuredImage { src }
                                images(first:1) {
                                  edges {
                                    node {
                                      originalSrc
                                      desktop: transformedSrc(maxWidth: 480)
                                      mobile: transformedSrc(maxWidth: 200)
                                    }
                                  }
                                }
                                variants(first: 1) {
                                    edges {
                                        node {
                                            id
                                            price { amount currencyCode }
                                            compareAtPrice { amount currencyCode }
                                        }
                                    }
                                }
                                options { values }
                                tags
                                metafields(identifiers: [{namespace: "12Storeez", key: "color"}, {namespace: "12Storeez", key: "colors_group"}]) {
                                    key
                                    value
                                }
                                productType
                            }
                          }
                        }
                    }
                }
            `;

            try {
                const response = await fetch(`${SHOP_URL}/api/2025-04/graphql.json`, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ query: graphqlQuery })
                });
                const data = await response.json()

                const products = data.data.products.edges.filter(edge => edge.node.variants).map((edge) => {
                    const product = edge.node;

                    const variant = product.variants.edges[0].node

                    this.isPredictiveSearch = false;
                    return {
                        title: product.title,
                        price_min: parseFloat(variant.price.amount).toFixed(2),
                        featured_image: {
                            url: product.featuredImage.src
                        },
                        tags: window.getTags(product.tags),
                        url: product.onlineStoreUrl
                    }
                })

                return {
                    products
                }
            } catch (error) {
                console.error('Error', error);
            }
        },

        displayProducts(products) {
            if (!products || !products.length) {
                this.showNotFound();
                this.hideButtonSearch();
                this.hideProducts();
                this.hideRecommended()
                this.hideContent()
                return;
            }

            this.$productsContainer.innerHTML = '';

            products.slice(0, 4).forEach(product => {
                const $productCard = document.createElement('div')
                let tagsContainer = '';

                if(product.tags && product.tags.length) {
                    tagsContainer = product.tags.map(tag => `<span class="product-card__tag">${tag}</span>`).join('');
                }


                $productCard.className = 'product-card';
                $productCard.innerHTML = `
                    <a href="${product.url}">
                        <div class="product-card__image">
                            <div
                                :id='product.wishlistId'
                                :data-id="product.wishlistId"
                                :data-bamboo-wishlist="JSON.stringify(product.wishlistData)"
                                class='bbw-favorites'
                                @click="handleWishlistClick"
                            ></div>
                            <img  class="product-card__image-source" src="${product.featured_image.url}" alt="${product.title}">
                        </div>
                        <h4 class="product-card__title">${product.title}</h4>
                        <div class="product-card__info">
                            <div class="product-card__price">
                                <span class="money">${Shopify.formatMoney( product.price_min, Shopify.money_format_duplicate )}</span>
                            </div>
                            <div class="product-card__colors">
                                <ProductPreviewColors v-bind:colors="product.otherColors" v-bind:product-handle="product.handle"/>
                            </div>
                        </div>
                            <div class="product-card__tags">${tagsContainer}</div>
                        </div>
                    </a>         
                `

                this.showButtonSearch()
                this.hideNotFound();
                this.showContent()
                this.hideRecommended()
                this.$productsContainer.appendChild($productCard);
                this.showProducts();
            })
        },

        displayCollections(collections) {
            if (!collections) {
                this.showCollections();
                this.hideCollectionsResults();
                return;
            }

            this.$collectionsResults.innerHTML = '';

            collections.forEach(collection => {
                const $collection = document.createElement('li')
                $collection.className = `${CLASS_NAME}__sidebar-list-item`;
                $collection.innerHTML = `
                    <a href="${collection.url}">${collection.title}</a>
                `;

                this.$collectionsResults.appendChild($collection);
                this.hideCollections()
                this.showCollectionsResults();
            })
        },

        showButtonSearch() {
            this.$buttonSearch.classList.add(`${CLASS_NAME}__button-search_visible`)
        },

        hideButtonSearch() {
            this.$buttonSearch.classList.remove(`${CLASS_NAME}__button-search_visible`)
        },

        setButtonSearchLink(query) {
            this.$buttonSearch.setAttribute('href', `https://12storeez.uz/search?q=${query}`)
        },

        displaySuggestions(suggestions, query) {
            if (!suggestions) {
                return;
            }

            const queryWords = query.match(/\b(\w+|\d+)\b/g);

            this.$suggestionsContainer.innerHTML = '';

            suggestions.forEach(suggestion => {
                let filteredSuggestion = suggestion.text.split(/\s+/)
                    .filter(word => !queryWords.includes(word))
                    .join(' ');

                if (filteredSuggestion) {
                    const $suggestion = document.createElement('li')
                    $suggestion.className = `${CLASS_NAME}__suggestion`;
                    $suggestion.innerHTML = filteredSuggestion;
                    $suggestion.setAttribute('data-query', suggestion.text)

                    this.$suggestionsContainer.appendChild($suggestion);
                    this.showSuggestions();
                }
            })
        },

        pasteSuggestion(suggestion) {
            this.$input.value = suggestion
            const eventInput = new Event('input');
            this.$input.dispatchEvent(eventInput);
        },

        showNotFound() {
            this.$notFound.style.display = 'flex'
        },

        hideNotFound() {
            this.$notFound.style.display = 'none'
        },

        showRecommended() {
            this.$recommended.style.display = 'block'
            this.$title.innerText = 'You may also like'
        },

        hideRecommended() {
            this.$recommended.style.display = 'none'
        },

        hideProducts() {
            this.$productsContainer.style.display = 'none'
        },

        showProducts() {
            this.$productsContainer.style.display = 'flex'
            this.$title.innerText = 'Вот что мы нашли'
        },

        hideContent() {
            this.$content.style.display = 'none'
        },

        showContent() {
            this.$content.style.display = 'flex'
        },

        showSuggestions() {
            this.$suggestionsContainer.style.display = 'flex';
        },

        hideSuggestions() {
            this.$suggestionsContainer.style.display = 'none';
        },

        showCollections() {
            this.$collections.style.display = 'block'
        },

        hideCollections() {
            this.$collections.style.display = 'none'
        },

        hideCollectionsResults() {
            this.$collectionsResults.style.display = 'none'
        },

        showCollectionsResults() {
            this.$collectionsResults.style.display = 'block'
        }
    }

    window.addEventListener('DOMContentLoaded', () => {
        componentHeaderSearch.init();
    });
})()
